export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.06bf50c7.worker.js");
}
